module.exports = __webpack_public_path__ + "static/img/tab_active_0.20572c43.png";